import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import { Col, Row, Space, Tabs } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  formatDateTime,
  formatDateWithoutTime,
  getBranchReasonMenuSelect,
  getBranchTaskStatus,
  isFilter,
  numberWithComma,
} from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { Pagination } from 'Components/Pagination'
import { SearchInput, SelectItem } from 'Components/form'
import LinkText from 'Components/text/LinkText'
import { Theme } from 'Components/common'
import { cloneDeep } from 'lodash'
import { EditOutlined, FileSearchOutlined } from '@ant-design/icons'
import { BranchTaskStatus, menuAgentBranchTaskStatus, SaleTaskStatus } from 'helpers/constanst'
import CustomerDetail from './detail'
import { selectLoginData, selectUserProfile } from 'Store/user/selector'
import { getAllCustomerTaskListAPI, getReasonListAPI } from 'Store/branch-task/api'
import { DataList, ListReq, ReasonReq, TaskBranch } from 'Store/branch-task/types'
import theme from 'Components/common/Theme'
import { selectList, selectListEvent, selectReasonList } from 'Store/branch-task/selector'
import { TaskSaleData } from 'Store/branch-task/types'
import ExpireDate from 'Components/common/ExpireDate'
const { TabPane } = Tabs

type Props = {} & RouteComponentProps & ReduxProps

const ChaiyoCustomerSaleTask: React.FunctionComponent<Props> = props => {
  const { listEvent, dataList, loginData, reasonList } = props
  const dispatch = useDispatch()
  const [resetFilter, setResetFilter] = useState(false)
  const [selected, setSelected] = useState({} as DataList)
  const [drawer, setDrawer] = useState(false)
  const [activeStatus, setActiveStatus] = useState(BranchTaskStatus.ONPROCESS as string)

  const initFilter = {
    start_date: '',
    end_date: '',
    merchant_id: 0,
    keyword: '',
    status: '',
    reason_id: 0,
  }
  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = dataList.meta
  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: ListReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      status: activeStatus,
      keyword: filter.keyword,
      reason_id: filter.reason_id,
    }
    dispatch(getAllCustomerTaskListAPI(req, loginData?.access_token || ''))
  }

  const onGetReasonListAPI = (type: string) => {
    const req: ReasonReq = {
      reason_type: type,
    }
    dispatch(getReasonListAPI(req, loginData?.access_token || ''))
  }

  // const onCountCustomer = (): void => {
  //   const req: CountReq = {}
  //   dispatch(countAllTaskAPI(req, loginData?.access_token || ''))
  // }

  useEffect(() => {
    if (loginData?.access_token) {
      onGetDataList()
      //onCountCustomer()
    }
  }, [pagination])

  useEffect(() => {
    if (activeStatus && activeStatus !== BranchTaskStatus.ONPROCESS) {
      onGetReasonListAPI(activeStatus)
    }
  }, [activeStatus])

  useEffect(() => {
    if (resetFilter) {
      onGetDataList()
      setResetFilter(false)
    }
  }, [resetFilter])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickEdit = (item: DataList) => {
    setSelected(item)
    onOpenDrawer()
  }

  const onSuccess = () => {
    // onCloseDrawer()
    onGetDataList()
    // onCountCustomer()
  }

  const onResetFilter = () => {
    setFilter(cloneDeep({ ...initFilter }))
    setResetFilter(true)
  }

  const renderStatus = (value: TaskSaleData, record: DataList) => {
    const result = getBranchTaskStatus(value.status)
    return <StatusTag color={result.color} text={result.text} reason={record?.task_sale?.reason || ''} />
  }

  const onChangeTab = (key: string) => {
    setFilter({
      ...filter,
      reason_id: 0,
    })
    setActiveStatus(key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const renderActionButton = (text: string, record: DataList) => {
    return (
      <Row justify="center" gutter={[8, 8]}>
        <Col>
          {record?.task_sale?.status === SaleTaskStatus.TOBRANCH ? (
            <ActionButton
              text=""
              icon={<EditOutlined />}
              label="แก้ไขข้อมูล"
              action="default"
              onClick={() => onClickEdit(record)}
              size="middle"
            />
          ) : (
            <ActionButton
              text=""
              icon={<FileSearchOutlined />}
              label="ดูข้อมูล"
              action="view"
              onClick={() => onClickEdit(record)}
              size="middle"
            />
          )}
        </Col>
      </Row>
    )
  }

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: '40px',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
    },
    {
      title: 'หมายเลขเคส',
      dataIndex: 'ams_case_no',
      key: 'ams_case_no',
      width: '130px',
      render: (val: string) => val || '-',
    },
    {
      title: 'สาขา',
      dataIndex: 'task_sale',
      key: 'task_sale',
      width: '120px',
      render: (val: TaskSaleData) => (val?.branch_customer).split(',')[0] || '-',
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'first_name',
      key: 'first_name',
      //render: renderAgentName,
    },
    {
      title: 'นามสกุล',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'mobile',
      key: 'mobile',
      width: '120px',
    },
    {
      title: 'รุ่นรถ',
      dataIndex: 'car_loan',
      key: 'car_model',
      render: (car_loan: any) => car_loan?.car_model || '',
    },
    {
      title: 'ราคาประเมิน',
      dataIndex: 'car_loan',
      key: 'amount_redbook',
      render: (car_loan: any) => numberWithComma(car_loan?.amount_redbook || 0, true),
    },
    // {
    //   title: 'วันที่สร้างข้อมูล',
    //   dataIndex: 'created_at',
    //   key: 'created_at',
    //   render: (val: string) => formatDateTime(val),
    // },
    {
      title: 'สถานะ',
      dataIndex: 'task_sale',
      key: 'task_sale',
      width: '100px',
      render: renderStatus,
    },
    {
      title: '',
      dataIndex: 'submit',
      key: 'submit',
      width: '80px',
      render: renderActionButton,
    },
  ]

  const onProcessColumns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: '40px',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
    },
    {
      title: 'หมายเลขเคส',
      dataIndex: 'ams_case_no',
      key: 'ams_case_no',
      width: '130px',
      render: (val: string) => val || '-',
    },
    {
      title: 'สาขา',
      dataIndex: 'task_sale',
      key: 'task_sale',
      width: '120px',
      render: (val: TaskSaleData) => (val?.branch_customer).split(',')[0] || '-',
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'first_name',
      key: 'first_name',
      //render: renderAgentName,
    },
    {
      title: 'นามสกุล',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'mobile',
      key: 'mobile',
      width: '120px',
    },
    {
      title: 'รุ่นรถ',
      dataIndex: 'car_loan',
      key: 'car_model',
      render: (car_loan: any) => car_loan?.car_model || '',
    },
    {
      title: 'ราคาประเมิน',
      dataIndex: 'car_loan',
      key: 'amount_redbook',
      render: (car_loan: any) => numberWithComma(car_loan?.amount_redbook || 0, true),
    },
    {
      title: 'วันที่นัดหมายเข้าสาขา',
      dataIndex: 'task_branch',
      key: 'appointment_date',
      // eslint-disable-next-line react/display-name
      render: (task: TaskBranch) =>
        task?.appointment_date ? <ExpireDate date={task?.appointment_date || ''} /> : '-',
    },
    {
      title: 'สถานะ',
      dataIndex: 'task_sale',
      key: 'task_sale',
      width: '100px',
      render: renderStatus,
    },
    {
      title: '',
      dataIndex: 'submit',
      key: 'submit',
      width: '80px',
      render: renderActionButton,
    },
  ]

  const cloaseColumns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: '40px',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
    },
    {
      title: 'หมายเลขเคส',
      dataIndex: 'ams_case_no',
      key: 'ams_case_no',
      width: '130px',
      render: (val: string) => val || '-',
    },
    {
      title: 'สาขา',
      dataIndex: 'task_sale',
      key: 'task_sale',
      width: '120px',
      render: (val: TaskSaleData) => (val?.branch_customer).split(',')[0] || '-',
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'first_name',
      key: 'first_name',
      //render: renderAgentName,
    },
    {
      title: 'นามสกุล',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'เบอร์โทรศัพท์',
      dataIndex: 'mobile',
      key: 'mobile',
      width: '120px',
    },
    {
      title: 'รุ่นรถ',
      dataIndex: 'car_loan',
      key: 'car_model',
      render: (car_loan: any) => car_loan?.car_model || '',
    },
    {
      title: 'ราคาประเมิน',
      dataIndex: 'car_loan',
      key: 'amount_redbook',
      render: (car_loan: any) => numberWithComma(car_loan?.amount_redbook || 0, true),
    },
    {
      title: 'วงเงินที่อนุมัติ',
      dataIndex: 'task_branch',
      key: 'approved_amount',
      render: (task: TaskBranch) => numberWithComma(task?.approved_amount || 0, true),
    },
    {
      title: 'วันที่อนุมัติ',
      dataIndex: 'task_branch',
      key: 'approved_date',
      // eslint-disable-next-line react/display-name
      render: (task: TaskBranch) => formatDateWithoutTime(task?.approved_date || '') || '-',
    },
    {
      title: 'สถานะ',
      dataIndex: 'task_sale',
      key: 'task_sale',
      width: '100px',
      render: renderStatus,
    },
    {
      title: '',
      dataIndex: 'submit',
      key: 'submit',
      width: '80px',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <CustomerDetail
      id={selected?.id || 0}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      isMe={true}
      isAgentChatSale={true}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <SearchInput
            name="keyword"
            placeholder="ค้นหาข้อมูลลูกค้า,หมายเลขเคส"
            value={filter.keyword}
            onChange={onFilter}
          />
        </Col>
        {activeStatus !== BranchTaskStatus.ONPROCESS && (
          <Col xs={24} md={8}>
            <SelectItem
              name={'reason_id'}
              label={''}
              isRequired={true}
              value={filter.reason_id}
              menu={getBranchReasonMenuSelect(reasonList)}
              placeHolder={'เหตุผล'}
              onChange={(val: any): void => onFilter('reason_id', val)}
            />
          </Col>
        )}
        <Col>
          <Space size="middle" align="center">
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} key="search" />
            {isFilter(filter) && (
              <LinkText color={Theme.colors.primary} onClick={onResetFilter}>
                ล้างการค้นหา
              </LinkText>
            )}
          </Space>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const renderTabs = () => {
    const tabs = menuAgentBranchTaskStatus
    return (
      <StickyHeader>
        <Tabs onChange={onChangeTab} activeKey={activeStatus}>
          {tabs.map((item: any) => {
            return <TabPane tab={`${item.name}`} key={item.value}></TabPane>
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  const getColumn = () => {
    let col = columns
    switch (activeStatus) {
      case BranchTaskStatus.ONPROCESS:
        col = onProcessColumns
        break
      case BranchTaskStatus.CLOSED:
        col = cloaseColumns
        break
    }
    return col
  }

  return (
    <>
      <HomePageLayout selected="branch-task" title="ข้อมูลลูกค้าที่นำส่งสาขา" label="">
        <br />
        {renderTabs()}
        {FilterContent}
        <TableListPage
          columns={getColumn()}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={null}
        />
        {PaginationContent}
        {/* {LoadingModal} */}
        {DetailDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    loginData: selectLoginData(state),
    userProfile: selectUserProfile(state),
    reasonList: selectReasonList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ChaiyoCustomerSaleTask)

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  z-index: 1;
  background-color: ${theme.colors.whitebg};
`
